import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LandingComponent } from './landing/landing.component';
import { ProfileComponent } from './profile/profile.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { Error403Component } from './error403/error403.component';
import { Error404Component } from './error404/error404.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResponseResetComponent } from './response-reset/response-reset.component';
import { AngularMaterialModule } from 'app/shared/angular-material.module';
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatetimeformatPipe } from 'app/pipe/datetimeformat.pipe';
import { SubstringTextPipe } from 'app/pipe/substring-text.pipe';
import { PaiementComponent } from './paiement/paiement.component';
import { PaiementHistoriqueComponent } from './paiement-historique/paiement-historique.component';
import { FormatdatetimestampPipe } from 'app/pipe/formatdatetimestamp.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        RouterModule,
        TextMaskModule,
        NgxDatatableModule,
        AngularMaterialModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        NgxSpinnerModule,
    ],
    declarations: [
        DatetimeformatPipe,
        SubstringTextPipe,
        LandingComponent,
        SignupComponent,
        SigninComponent,
        ProfileComponent,
        SignupComponent,
        Error403Component,
        Error404Component,
        ForgetPasswordComponent,
        ResponseResetComponent,
        PaiementComponent,
        PaiementHistoriqueComponent,
        FormatdatetimestampPipe
    ],
    exports: [
        DatetimeformatPipe,
        SubstringTextPipe,
        SignupComponent,
        SigninComponent,
        Error403Component,
        TextMaskModule,
        NgxDatatableModule,
        PaiementComponent,
        PaiementHistoriqueComponent,
        FormatdatetimestampPipe
    ],
})
export class WidgetModule { }
